var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article"},[_c('ContentBlock',{attrs:{"breadcrumbs-title":_vm.articleData ? _vm.articleData.title : '',"breadcrumbs-list":_vm.breadcrumbs,"data":_vm.articleData,"is-can-share":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }